'use client'
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What kind of graphic design services do you offer?",
    answer: "We provide a full range of design services including logo design, social media creatives, banners, brochures, packaging, business cards, and website graphics — tailored to reflect your brand identity."
  },
  {
    question: "Can you create designs that match my brand guidelines?",
    answer: "Yes, absolutely. Whether you have existing brand guidelines or want us to build your visual identity from scratch, we ensure consistency and creativity in every design element we deliver."
  },
  {
    question: "How do you handle revisions if I want changes?",
    answer: "We offer multiple revision rounds based on your package. Our goal is to ensure you're fully satisfied with the final design, and we welcome your input throughout the creative process."
  },
  {
    question: "Do you also design for social media platforms?",
    answer: "Yes! We design eye-catching posts, stories, and ad creatives for platforms like Instagram, Facebook, LinkedIn, and more — optimized for engagement and aligned with your campaign goals."
  },
  {
    question: "What’s the typical turnaround time for a project?",
    answer: "It depends on the complexity and type of design. Logos typically take 2–3 days, while full branding or marketing kits may take up to a week. We always provide realistic deadlines before starting."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center ' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                   <span
                      className={`transition-colors duration-200 cursor-pointer 
                        hover:text-purple-600 
                        ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
                    >{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
